import React, { useState } from "react";

// Importing redux components
import { useDispatch, useSelector } from "react-redux";

// Importing toast utilities
import { showSuccessToast } from "utils/toast";

// Importing user mutations
import { useUpdateUserMutation } from "state/slices/user/userApiSlice";

// Importing auth slice
import { updateUserInfo } from "state/slices/auth/authSlice";

// Importing validations
import { valiDateOptionalFormField, } from 'validations';
import PayrollNotes from "./PayrollNotes";
import { useDeletePayrollNotesMutation, useUpdatePayrollNotesMutation } from "state/slices/analytics/analyticsApiSlice";

const initialValues = {
  id: null,
  cl: "",
  totalDD: "",
};

const GeneralAccessManagement = React.memo(
  ({ isAllowedToUpdate, AnalyticsViewManagement, isAllowedToUpdatePayrollNotes }) => {

    const dispatch = useDispatch();

    const { userInfo: loggedUserInfo } = useSelector((state) => state.auth);
    
    const [selectedRow, setSelectedRow] = useState(initialValues);
    const [formikValues, setFormikValues] = useState(initialValues);

    // Salary Notes
    const [updatePayrollNotes] = useUpdatePayrollNotesMutation();
    const [deletePayrollNotes] = useDeletePayrollNotesMutation();

    const handleCheckboxChange = (event, row) => {
      const { id, cl, totalDD, ...restRow } = row;

      if (event.target.checked) {
        setSelectedRow({
          id,
          cl,
          totalDD,
        });

        setFormikValues({
          id,
          cl,
          totalDD,
        });
      } else {
        setSelectedRow(initialValues);
        setFormikValues(initialValues);
      }
    };

    const handleChange = (event) => {
      const target = event.target;

      setFormikValues({
        ...formikValues,
        [target.name]: target.value,
      });
    };

    const [updateUser] = useUpdateUserMutation();
    const updateAnalytics = async (refetchAnalytics) => {
      try {

        const formData = {
          ...formikValues,
        };

        // Check if CL is valid
        if ( ! valiDateOptionalFormField( formData.cl ) ) {
          delete formData.cl;
        }

        // Check if totalDD is valid
        if ( ! valiDateOptionalFormField( formData.totalDD ) ) {
          delete formData.totalDD;
        }

        // Check if CL is changed
        if (formData.cl === selectedRow.cl) {
          delete formData.cl;
        }

        // Check if Total Deduction Days is changed
        if (formData.totalDD === selectedRow.totalDD) {
          delete formData.totalDD;
        }

        // Use the "updateUser" mutation function for updating an existing user
        const updatedUser = await updateUser(formData).unwrap();

        // Update user in local storage
        if ( loggedUserInfo?.id === updatedUser?.id ) {
          dispatch(
            updateUserInfo({
              field: "replace",
              data: updatedUser,
            })
          );
        }

        // Reset Values
        setSelectedRow(initialValues);
        setFormikValues(initialValues);

        refetchAnalytics();
        
        showSuccessToast('User updated successfully');
      } catch (err) {
        // Error toast is automatically shown by baseQuery
      }
    };

    return (
      <>
        {isAllowedToUpdatePayrollNotes && <PayrollNotes updatePayrollNotes={updatePayrollNotes} deletePayrollNotes={deletePayrollNotes} />}
        <AnalyticsViewManagement
          isAllowedToUpdate={isAllowedToUpdate}
          handleCheckboxChange={handleCheckboxChange}
          selectedRow={selectedRow}
          formikValues={formikValues}
          handleChange={handleChange}
          updateAnalytics={updateAnalytics}
        />
      </>
    );
  }
);

export default GeneralAccessManagement;
